export default "__VITE_ASSET__3ad4ef31__"